// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".byForm[data-v-7f476426]{position:relative}.error-submit[data-v-7f476426]{position:absolute;top:-20px;color:red}", ""]);
// Exports
module.exports = exports;
